module.exports = __webpack_public_path__ + "img/icon-fanish.eac65ed6.png";